function initPdpGallery() {
  const thumbsSwiperEl = document.getElementById('PdpThumbsSwiper');
  const mainSwiperEl = document.getElementById('PdpMainSwiper');
  const mainGalleryContainer = document.querySelector('.pdp-gallery__main');
  const thumbsWrapper = document.querySelector('.pdp-gallery__thumbs-wrapper');

  let mainSwiper = null;
  let thumbsSwiper = null;

  function syncAndInit() {
    if (typeof Swiper === 'undefined') return;

    // --- Main Image Swiper ---
    if (mainSwiperEl) {
      if (!mainSwiperEl.swiper) {
        mainSwiper = new Swiper('#PdpMainSwiper', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          grabCursor: true,
          watchOverflow: true,
          on: {
            slideChange: function () {
              // Sync thumbnail active state
              const allThumbs = document.querySelectorAll('.pdp-gallery__thumb-item');
              allThumbs.forEach((t, i) => {
                t.classList.toggle('is-active', i === this.activeIndex);
              });
              // Scroll thumb into view
              if (thumbsSwiperEl && thumbsSwiperEl.swiper) {
                thumbsSwiperEl.swiper.slideTo(this.activeIndex);
              }
            },
          },
        });
      } else {
        mainSwiper = mainSwiperEl.swiper;
        mainSwiper.update();
      }
    }

    // --- Thumbnails Swiper ---
    if (thumbsSwiperEl) {
      if (window.innerWidth > 998) {
        // Desktop: sync thumbnail wrapper height to main image
        let mainHeight = 0;
        if (mainGalleryContainer && mainGalleryContainer.clientHeight > 50) {
          mainHeight = mainGalleryContainer.clientHeight;
        } else if (mainGalleryContainer && mainGalleryContainer.clientWidth > 50) {
          mainHeight = mainGalleryContainer.clientWidth;
        } else {
          mainHeight = 588;
        }

        const itemSize = Math.floor((mainHeight - (5 * 12)) / 6);

        if (thumbsWrapper && itemSize > 0) {
          thumbsWrapper.style.flex = `0 0 ${itemSize}px`;
          thumbsWrapper.style.width = `${itemSize}px`;
        }

        thumbsSwiperEl.style.height = `${mainHeight}px`;
      } else {
        if (thumbsWrapper) {
          thumbsWrapper.style.flex = '';
          thumbsWrapper.style.width = '';
        }
        thumbsSwiperEl.style.height = '';
      }

      if (!thumbsSwiperEl.swiper) {
        thumbsSwiper = new Swiper('#PdpThumbsSwiper', {
          direction: 'vertical',
          slidesPerView: 6,
          spaceBetween: 12,
          freeMode: true,
          mousewheel: true,
          grabCursor: true,
          scrollbar: {
            el: '.pdp-thumbs-scrollbar',
            draggable: true,
            snapOnRelease: false,
          },
          breakpoints: {
            0: {
              direction: 'horizontal',
              slidesPerView: 3.7,
              spaceBetween: 8,
              slidesOffsetAfter: 20,
            },
            999: {
              direction: 'vertical',
              slidesPerView: 6,
              spaceBetween: 12,
              slidesOffsetAfter: 0,
            },
          },
        });
      } else {
        thumbsSwiper = thumbsSwiperEl.swiper;
        thumbsSwiper.update();
      }
    }
  }

  // Wait for the main swiper container to be ready
  if (mainSwiperEl) {
    const firstImg = mainSwiperEl.querySelector('img');
    if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', syncAndInit);
    } else {
      syncAndInit();
    }
  } else {
    syncAndInit();
  }

  window.addEventListener('resize', syncAndInit);

  // Thumbnail Click Switcher with Event Delegation
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.pdp-gallery__thumb-item');
    if (!thumb) return;

    e.preventDefault();

    const allThumbs = document.querySelectorAll('.pdp-gallery__thumb-item');
    let clickedIndex = 0;
    allThumbs.forEach((t, i) => {
      t.classList.remove('is-active');
      if (t === thumb) clickedIndex = i;
    });
    thumb.classList.add('is-active');

    // Slide main swiper to the clicked thumbnail's index
    const mainSwiperInstance = mainSwiperEl && mainSwiperEl.swiper;
    if (mainSwiperInstance) {
      mainSwiperInstance.slideTo(clickedIndex);
    }
  });

  // Sticky Bottom Bar Trigger on Scroll Past Main Add to Cart Form
  const stickyBar = document.getElementById('PdpStickyBar');
  const mainActions = document.querySelector('.pdp-actions');

  if (stickyBar && mainActions) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
              stickyBar.classList.add('is-visible');
            } else {
              stickyBar.classList.remove('is-visible');
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(mainActions);
    } else {
      window.addEventListener('scroll', () => {
        const rect = mainActions.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdpGallery);
} else {
  initPdpGallery();
}

window.addEventListener('load', initPdpGallery);
